
import { supabase, handleSupabaseError } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";

export const useContractors = (serviceType: string, locationFilter: string) => {
  return useQuery({
    queryKey: ['contractors', serviceType, locationFilter],
    queryFn: async () => {
      console.log('Fetching contractors with service type:', serviceType, 'and location:', locationFilter);
      try {
        let query = supabase
          .from('contractors')
          .select('*')
          .order('rating', { ascending: false });

        if (serviceType && serviceType !== 'all') {
          query = query.eq('service_type', serviceType);
        }
        
        if (locationFilter && locationFilter !== 'all') {
          query = query.eq('location', locationFilter);
        }

        const { data, error } = await query;
        
        if (error) {
          console.error('Error fetching contractors:', error);
          return handleSupabaseError(error);
        }

        console.log('Successfully fetched contractors:', data);
        return data || [];
      } catch (error) {
        return handleSupabaseError(error);
      }
    },
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};
